import { render, staticRenderFns } from "./myMessage.vue?vue&type=template&id=6220a81f&scoped=true&"
import script from "./myMessage.vue?vue&type=script&lang=js&"
export * from "./myMessage.vue?vue&type=script&lang=js&"
import style0 from "./myMessage.vue?vue&type=style&index=0&id=6220a81f&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6220a81f",
  null
  
)

export default component.exports